<template>
    <div class="stepper">
        <div class="row justify-content-center">
            <div class="col">

                <transition name="slide-fade">
                    <div id="first" v-if="retirement.firstStepActive === 1">
                        <div class="mb-3">
                            <div class="row">
                                <div class="col-12 col-sm-4">
                                    <div class="row align-items-center form-group">
                                        <div class="col-auto">
                                            <img class="img-fluid icon" src="../assets/images/gender.png">
                                        </div>
                                        <div class="col label no-padding">
                                            เพศ
                                        </div>
                                    </div>
                                </div>

                                <div class="col-auto">
                                    <div>
                                        <md-radio v-model="form.gender" value="M">ชาย</md-radio>
                                        <md-radio v-model="form.gender" value="F">หญิง</md-radio>
                                    </div>
                                    <error-message :msg="errorMessage.gender"></error-message>
                                </div>
                            </div>
                        </div>


                        <div class="mb-3">
                            <div class="row">
                                <div class="col-12 col-sm-4">
                                    <div class="row align-items-center form-group">
                                        <div class="col-auto">
                                            <img class="img-fluid icon" src="../assets/images/age.png">
                                        </div>
                                        <div class="col label no-padding">
                                            อายุปัจจุบัน (ปี)
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 col-sm form-group input-group-lg">
                                    <input type="number" v-model="form.currentAge" class="form-control"
                                           placeholder="โปรดระบุ">
                                    <error-message :msg="errorMessage.currentAge"></error-message>
                                </div>
                            </div>
                        </div>


                        <div class="mb-3">
                            <div class="row align-items-center">
                                <div class="col-12 col-sm-4 form-group">
                                    <div class="row align-items-center ">
                                        <div class="col-auto">
                                            <img class="img-fluid icon" src="../assets/images/retire.png">
                                        </div>
                                        <div class="col label no-padding">
                                            อายุที่ต้องการเกษียณ (ปี)
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm form-group input-group-lg">
                                    <input type="number" v-model="form.retiredAge" class="form-control"
                                           placeholder="โปรดระบุ">
                                    <error-message :msg="errorMessage.retiredAge"></error-message>
                                </div>
                            </div>
                        </div>


                        <div class="row justify-content-center">
                            <div class="col-auto">
                                <div class="button-yellow" @click="nextSubStep(2, 'next')">ถัดไป</div>
                            </div>
                        </div>

                    </div>
                </transition>


                <transition name="slide-fade">
                    <div id="second" v-if="retirement.firstStepActive === 2">


                        <div class="form-group text-center">
                            เลือกไลฟ์สไตล์ ค่าใช้จ่ายที่ต้องการใช้ในยามเกษียณ (มูลค่า ณ ปัจจุบัน)
                        </div>


                        <div class="row justify-content-center lifeStyle">
                            <div class="col-auto mb-3 mt-3">
                                <input id="level_1" type="radio" v-model="form.spendingPerMonth" value="10000">
                                <label for="level_1">
                                    <img class="img-fluid img-lifeStyle" src="../assets/images/life_style_level_1.png">
                                </label>
                            </div>

                            <div class="col-auto mb-3 mt-3">
                                <input id="level_2" type="radio" v-model="form.spendingPerMonth" value="30000">
                                <label for="level_2">
                                    <img class="img-fluid img-lifeStyle" src="../assets/images/life_style_level_2_30000.jpg">
                                </label>
                            </div>

                            <div class="col-auto mb-3 mt-3">
                                <input id="level_3" type="radio" v-model="form.spendingPerMonth" value="50000">
                                <label for="level_3">
                                    <img class="img-fluid img-lifeStyle" src="../assets/images/life_style_level_3_50000.jpg">
                                </label>
                            </div>
                        </div>
                        <div class="form-group text-center">
                           หากต้องการมีคุณภาพชีวิตใกล้เคียงเดิม<br>ค่าใช้จ่ายหลังเกษียณจะอยู่ที่ร้อยละ 60-70 ของเงินเดือน เดือนสุดท้าย
                        </div>

                        <transition name="slide-fade">
                            <div class="form-group text-center">
                                <div class="row justify-content-center align-items-center">
                                    <div class="col-auto form-group"> ค่าใช้จ่ายที่ต้องการใช้ในยามเกษียณ</div>
                                    <div class="col-auto form-group input-group-lg">
                                        <money v-bind="money" v-model="form.spendingPerMonth"
                                               class="form-control input-money-center"
                                               placeholder="โปรดระบุ"></money>
                                    </div>
                                    <div class="col-auto form-group"> บาท/เดือน
                                        <span>
                                        <img class="img-fluid icon-info"
                                             @click="customSpendingPerMonth()"
                                             src="../assets/images/edit.png">
                                             <md-tooltip class="tooltip-mode">ปรับรายละเอียดค่าใช้จ่าย</md-tooltip>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </transition>

                        <div class="row justify-content-center">
                            <div class="col-auto">
                                <div class="button-accent" @click="nextSubStep(1)">ย้อนกลับ</div>
                            </div>
                            <div class="col-auto">
                                <div class="button-yellow" @click="nextSubStep(3 ,'next')">ถัดไป</div>
                            </div>
                        </div>

                    </div>
                </transition>

                <transition name="slide-fade">
                    <div id="third" v-if="retirement.firstStepActive === 3">

                        <div class="form-group text-center">
                            เลือกแผนการใช้เงินก้อนเพิ่มเติมที่คาดว่าจะใช้หลังเกษียณ (สามารถเลือกได้มากกว่า 1 ข้อ)
                        </div>

                        <div class="row retirementPlan">
                            <div class="col-6 col-sm">
                                <input id="repayDebt" type="checkbox" v-model="form.retirementPlan" value="repayDebt">
                                <label for="repayDebt">
                                    <img class="img-fluid"
                                         v-bind:src="form.retirementPlan.indexOf('repayDebt') === -1 ? `./button/debt.png` : `./button/check_debt.png`">
                                </label>

                                <div class="form-group input-group-lg">
                                    <money v-bind="money" class="form-control" v-model="form.spendingBigDebt"
                                           :disabled="form.retirementPlan.indexOf('repayDebt') === -1"></money>
                                </div>
                            </div>


                            <div class="col-6 col-sm">
                                <input id="buyCar" type="checkbox" v-model="form.retirementPlan" value="buyCar">
                                <label for="buyCar">
                                    <img class="img-fluid"
                                         v-bind:src="form.retirementPlan.indexOf('buyCar') === -1 ? `./button/car.png` : `./button/check_car.png`">
                                </label>

                                <div class="form-group input-group-lg">
                                    <money v-bind="money" class="form-control" v-model="form.spendingBigCar"
                                           :disabled="form.retirementPlan.indexOf('buyCar') === -1"></money>
                                </div>
                            </div>


                            <div class="col-6 col-sm">
                                <input id="ect" type="checkbox" v-model="form.retirementPlan" value="ect">
                                <label for="ect">
                                    <img class="img-fluid "
                                         v-bind:src="form.retirementPlan.indexOf('ect') === -1 ? `./button/lineage.png` : `./button/check_lineage.png`">
                                </label>

                                <div class="form-group input-group-lg">
                                    <money v-bind="money" class="form-control" v-model="form.spendingBigEtc"
                                           :disabled="form.retirementPlan.indexOf('ect') === -1"></money>
                                </div>

                            </div>


                            <div class="col-6 col-sm">
                                <input id="travel" type="checkbox" v-model="form.retirementPlan" value="travel">
                                <label for="travel">
                                    <img class="img-fluid"
                                         v-bind:src="form.retirementPlan.indexOf('travel') === -1 ? `./button/travel.png` : `./button/check_travel.png`">
                                </label>

                                <div class="form-group input-group-lg">
                                    <money v-bind="money" class="form-control" v-model="form.spendingBigTourist"
                                           :disabled="form.retirementPlan.indexOf('travel') === -1"></money>
                                </div>

                            </div>


                            <div class="col-6 col-sm">
                                <input id="nurse" type="checkbox" v-model="form.retirementPlan" value="nurse">
                                <label for="nurse">
                                    <img class="img-fluid"
                                         v-bind:src="form.retirementPlan.indexOf('nurse') === -1 ? `./button/medical.png` : `./button/check_medical.png`">
                                </label>

                                <div class="form-group input-group-lg">
                                    <money v-bind="money" class="form-control" v-model="form.spendingBigNurse"
                                           :disabled="form.retirementPlan.indexOf('nurse') === -1"></money>
                                </div>

                            </div>

                        </div>


                        <div class="row justify-content-center">
                            <div class="col-auto">
                                <div class="button-accent" @click="nextSubStep(2)">ย้อนกลับ</div>
                            </div>
                            <div class="col-auto">
                                <div class="button-yellow" @click="nextStep(2)">ถัดไป</div>
                            </div>
                        </div>

                    </div>
                </transition>

            </div>
        </div>


        <dialog-normal :data="dataDialogNormal" :show="showDialogNormal" :dialog="dialog"
                       @close="close"></dialog-normal>


        <dialog-spending-per-month :data="dataDialogSpendingPerMonth" :show="showDialogSpendingPerMonth"
                                   :dialog="dialog"
                                   @close="closeSpendingPerMonth"></dialog-spending-per-month>

    </div>
</template>

<script>

  import store from '../store';
  import {SET_ACTIVE, SET_SUB_ACTIVE, SET_STEPPER_DATA} from '../store/actions.type'
  import {mapState} from 'vuex';
  import * as validate from 'validate.js'
  import ErrorMessage from "./errorMessage";
  import DialogNormal from "./dialogNormal";
  import DialogSpendingPerMonth from "./dialogSpendingPerMonth";

  export default {
    name: 'StepperFirst',
    components: {DialogSpendingPerMonth, DialogNormal, ErrorMessage},
    computed: mapState({
      retirement: state => state.retirement,
      form: state => state.retirement.data.first,
      spendingPerMonth: state => state.retirement.data.first.spendingPerMonth
    }),
    data: () => ({
      errorMessage: {},
      dialog: {
        header: null,
        message: null,
      },
      showDialogNormal: false,
      dataDialogNormal: {},

      showDialogSpendingPerMonth: false,
      dataDialogSpendingPerMonth: {},

      money: {
        thousands: ',',
        precision: 0,
        masked: false
      }

    }),
    methods: {
      nextSubStep(nextStep, direction) {

        if (direction === 'next') {
          let errorMessage = this.validateForm(nextStep, this.form);

          if (errorMessage.spendingPerMonth) {
            this.showDialogNormal = true;
            this.dialog.message =
              `<div class="text-center "><div class="md-display-1 mb-2 txt-navy"> กรุณาเลือก </div>
               <div class="md-title mb-3">ค่าใช้จ่ายที่ใช้ในยามเกษียณ</div></div>
              `

          }

          if (errorMessage) {
            return this.errorMessage = errorMessage;
          }
        }

        this.errorMessage = {};
        store.dispatch(SET_SUB_ACTIVE, {key: 'firstStepActive', step: nextStep});
      },

      nextStep(step) {
        store.dispatch(SET_ACTIVE, step);
        store.dispatch(SET_STEPPER_DATA, {key: 'first', data: this.form});
      },

      close() {
        this.showDialogNormal = false;
      },


      validateForm(nextStep, data) {
        let errMessageList = null;
        let validateRule = {};

        // set rule
        if (nextStep === 2) {
          validateRule = {
            gender: {
              presence: {
                allowEmpty: false,
                message: "^โปรดระบุ: เพศ"
              },
            },
            currentAge: {
              presence: {
                allowEmpty: false,
                message: "^โปรดระบุ: อายุปัจจุบัน"
              },
              numericality: {
                greaterThan: 0,
                lessThan: parseFloat(data.retiredAge),
              }
            },
            retiredAge: {
              presence: {
                allowEmpty: false,
                message: "^โปรดระบุ: อายุที่ต้องการเกษียณ"
              },
              numericality: {
                greaterThanOrEqualTo: 50,
                lessThanOrEqualTo: 70,
              },
            },
          };


          // set data to validate
          errMessageList = validate(
            {
              gender: data.gender,
              currentAge: data.currentAge ? parseFloat(data.currentAge) : null,
              retiredAge: data.retiredAge ? parseFloat(data.retiredAge) : null,
            }, validateRule);

        } else if (nextStep === 3) {


          validateRule = {
            spendingPerMonth: {
              presence: {
                allowEmpty: false,
                message: "^โปรดระบุ: ค่าใช้จ่ายที่ใช้ในยามเกษียณ"
              },
              numericality: {
                greaterThan: 0,
                message: "^โปรดระบุ: ค่าใช้จ่ายที่ใช้ในยามเกษียณ"
              }
            }
          };

          // set data to validate
          errMessageList = validate(
            {
              spendingPerMonth: data.spendingPerMonth,
            }, validateRule);
        }


        if (errMessageList) {
          const error = {};
          for (const [key, value] of Object.entries(errMessageList)) {

            let message = value[0];

            // custom message
            if (message === 'Current age must be greater than 0') {
              message = 'อายุปัจจุบัน ไม่ถูกต้อง';
            } else if (message === 'Retired age must be greater than or equal to 50' || message === 'Retired age must be less than or equal to 70') {
              message = 'กรุณากรอกอายุที่ต้องการเกษียณในช่วง 50 - 70 ปี';
            } else if (message.includes("Current age must be less than")) {
              message = 'กรุณากรอกอายุปัจจุบันน้อยกว่าอายุที่ต้องการเกษียณ';
            }

            error[key] = message;
          }
          return error;
        } else {
          return false;
        }
      },

      customSpendingPerMonth() {
        this.dataDialogSpendingPerMonth = {
          spendingPerMonth: this.form.spendingPerMonth
        };

        this.showDialogSpendingPerMonth = true;
      },

      closeSpendingPerMonth(data) {
        this.form.spendingPerMonth = data.spendingPerMonth;
        this.showDialogSpendingPerMonth = false;
      },

      calculate() {

      }

    },

  }
</script>

<style scoped lang="scss">
    @import "../assets/css/colors";

    ::-webkit-input-placeholder {
        text-align: center;
    }

    :-moz-placeholder { /* Firefox 18- */
        text-align: center;
    }

    ::-moz-placeholder { /* Firefox 19+ */
        text-align: center;
    }

    :-ms-input-placeholder {
        text-align: center;
    }

    .icon-info {
        max-height: 20px;
        margin-top: -10px;
        cursor: pointer;
    }

    .md-radio {
        margin: 16px 16px 0 0;
    }
.input-money-center{
  text-align: center;
}
</style>
